
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    pToggleInquiryModal: Function as any,
	},
  data() {
    return {
			showSideMenu: false,
			mSubMenuShow: false,
			mYesMobile: false,
			mSelectedMenuIndex: 0,
			mSubMenuList: [
				{ title: '팀플 문서 뷰어', goToPage:'/viewer' },
				{title: '팀플 문서 변환', goToPage:'/changer' },
				{title: '팀플 개인정보 필터', goToPage:'/filter' },
			],
			scrollingYn: false
		};
  },
	methods: {
		goTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
		goToUtils() {
			this.$router.push('/');
			this.goTop();
		},
		goToViewer() {
			this.$router.push('/viewer')
		},
		goToChanger() {
			this.$router.push('/changer')
		},
		goToFilter() {
			this.$router.push('/filter')
		},
		goToFaq() {
			this.$router.push('/faq')
		},
		goToDeveloper() {
			this.$router.push('/developer')
		},
		goToIntro() {
			this.$router.push('/intro')
		},
		toggleSideMenu() {
			this.showSideMenu = !this.showSideMenu;
		},
		showSubMenu() {
			this.mSubMenuShow = true
		},
		closeSubMenu() {
			this.mSubMenuShow = false
		},
		handleResize() {
			const windowWidth = window.innerWidth;
			this.mYesMobile = windowWidth <= 1024;
		},
		getHeight(elementId: any, index: number) {
			this.mSelectedMenuIndex = index
			const element = document.getElementById(elementId);
		},
		handleScroll() {
			const windowScrollY = window.scrollY;
			// console.log('windowScrollY', windowScrollY)
			if (windowScrollY > 100) {
				this.scrollingYn = true
			}
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', () => {
			this.handleScroll();
		});
		this.handleResize();
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}
});
